import React from 'react';

import styles from './actions.module.scss';
import Button, { ButtonSize, ButtonVariant } from 'src/components/ui-kit/button/button';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

export default function ContactActions(): JSX.Element {
  const { t } = useTranslation(['components:pages:contact']);

  return (
    <div className={styles.actions}>
      <Link
        href='/blog/industry-news/free-consultation/'
        className={styles.actions_link}>
        <Button
          className={styles.actions_button}
          size={ButtonSize.LARGE}
          variant={ButtonVariant.PRIMARY}>
          {t('BUTTON_CONTACT_FORM')}
        </Button>
      </Link>
      <Link
        href='/blog/industry-news/free-consultation/'
        className={styles.actions_link}>
        <Button
          className={styles.actions_button}
          size={ButtonSize.LARGE}
          variant={ButtonVariant.PRIMARY}>
          {t('BUTTON_FREE_CONSULTATION')}
        </Button>
      </Link>
    </div>
  );
}
